(function () {
  'use strict';

  var blockedUrl = /(?:\/cart(?:\/|[?#]|$)|\/checkouts?(?:\/|[?#]|$)|\/wallets?(?:\/|[?#]|$)|\/accelerated-checkout(?:\/|[?#]|$)|\/shop-pay(?:\/|[?#]|$)|shop\.app\/(?:pay|checkout)|shopify\.com\/(?:pay|checkouts?)|amazon\.|walmart\.)/i;

  function isBlockedUrl(value) {
    return blockedUrl.test(String(value || ''));
  }

  window.HaroHKNoCommerce = Object.freeze({ isBlockedUrl: isBlockedUrl });

  if (!document.body || document.body.getAttribute('data-hk-no-commerce') !== 'true') return;

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href]');
      if (!link || !isBlockedUrl(link.href)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var action = event.target && event.target.action ? event.target.action : '';
      var submitter = event.submitter;
      var isCheckout = submitter && submitter.name === 'checkout';
      if (!isCheckout && !isBlockedUrl(action)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );
})();
